import fetchServer from "../../fetchServer";
import { PDF_API_BASE } from "./pdfApiBase";

/**
 * POST /api/v1/credentials — create Adobe PDF credential (admin).
 * Body: { label, clientId, clientSecret, enabled? }
 */
export default async function createPdfCredential(data) {
  let result = {
    return: 0,
    msg: "Something went wrong creating PDF credential",
  };

  try {
    const res = await fetchServer({
      method: "POST",
      url: "/api/v1/credentials",
      data,
      api: PDF_API_BASE,
    });

    if (res?.data && !res?.data?.error) {
      result = {
        return: 1,
        msg: res.data?.message || "Successful",
        data: res.data?.data ?? res.data,
      };
    } else if (res?.data?.error) {
      result.msg = res.data.error;
    } else if (res?.error) {
      result.msg = res.error;
    } else if (res?.data?.message) {
      result.msg = res.data.message;
    } else if (res?.msg) {
      result.msg = res.msg;
    }
  } catch (err) {
    console.log("Network Error!", err);
  }

  return result;
}
